import React, { useContext, useEffect, useState } from 'react';
import Modal from 'react-overlays/Modal';
import styled from 'styled-components';
import { TmsContext } from '../../../tms/TmsContext';
import { SegmentWithHeader } from '../../../../shared/SegmentWithHeader';
import { toCurrency } from '../../../../utilities/FormatHelpers';
import { AccountContext } from '../../AccountContext';
import { useAsyncEffect } from '../../../../hooks/UseAsyncEffect';

const CreditAllocationDetailsModal = styled(Modal)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: fit-content;
  z-index: 1040;
  background-color: white;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
`;

export default function CreditAllocationDetails({ transaction }: { transaction: any }) {
  const { accountId, creditAllocationService, setError } = useContext(AccountContext);
  const [popupVisible, setPopupVisible] = useState(false);
  const [close, setResult] = useState(false);
  const [detailedAllocations, setDetailedAllocations] = useState();
  useContext(TmsContext);

  useEffect(() => {
    if (close) {
      closePopup();
    }
  }, [close]);

  useAsyncEffect(async () => {
    try {
      if (transaction) {
        setDetailedAllocations(null);
        setPopupVisible(true);
        setDetailedAllocations(
          await creditAllocationService.getPaymentAllocations(accountId, transaction.transactionId)
        );
      }
    } catch (error) {
      setError({ source: 'CreditAllocationDetails', ...error });
    }
  }, [transaction]);

  const closePopup = () => {
    setResult(undefined);
    setPopupVisible(false);
  };

  return (
    <div>
      <CreditAllocationDetailsModal show={popupVisible} onHide={closePopup} aria-labelledby="modal-label">
        <SegmentWithHeader
          header={`${transaction?.description} (${transaction?.transactionId})`}
          onClose={closePopup}
          className={'basic'}>
          {detailedAllocations != undefined && detailedAllocations.creditAllocationSteps.length > 0 && (
            <table className="ui celled structured table">
              <thead>
                <tr>
                  <th rowSpan={2}>#</th>
                  <th rowSpan={2}>Step</th>
                  <th colSpan={6}>Allocations</th>
                </tr>
                <tr>
                  <th>#</th>
                  <th>Subledger</th>
                  <th>Spend Type</th>
                  <th>Balance Type</th>
                  <th>Split Type</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {detailedAllocations.creditAllocationSteps.map((a) => (
                  <React.Fragment key={a.index}>
                    <tr>
                      <td
                        rowSpan={
                          (a.allocations == undefined ? [] : a.allocations).length === 0 ? 1 : a.allocations.length
                        }>
                        {a.index}
                      </td>
                      <td
                        rowSpan={
                          (a.allocations == undefined ? [] : a.allocations).length === 0 ? 1 : a.allocations.length
                        }>
                        {a.allocationStep}
                      </td>
                      <td>{a.allocations[0]?.index ?? ''}</td>
                      <td>{a.allocations[0]?.subledgerId ?? ''}</td>
                      <td>{a.allocations[0]?.spendType ?? ''}</td>
                      <td>{a.allocations[0]?.balanceType ?? ''}</td>
                      <td>{a.allocations[0]?.splitType ?? ''}</td>
                      <td>{toCurrency(a.allocations[0]?.amount.value ?? '')}</td>
                    </tr>
                    {a.allocations.slice(1).map((b) => (
                      <React.Fragment key={b.index}>
                        <tr>
                          <td>{b.index}</td>
                          <td>{b.subledgerId}</td>
                          <td>{b.spendType}</td>
                          <td>{b.balanceType}</td>
                          <td>{b.splitType}</td>
                          <td>{toCurrency(b.amount.value)}</td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          )}
        </SegmentWithHeader>
      </CreditAllocationDetailsModal>
    </div>
  );
}
